import { FC } from 'react';
import { Header } from '../../../shared/header/header';
import { LoadText } from '../../../shared/loading/loadText';
import { ScrollTable } from '../../../shared/table/scrollTable';
import { UserInfo } from './../../../../models/userInfo';
import styles from './responderStaff.module.css';

const COLUMNS = {
    name: '',
    role: ''
}

export const ResponderStaff: FC<{
    responders: UserInfo[],
    loading: boolean
}> = ({
    responders,
    loading
}) => {


    const getLoadingRow = () => Object.keys(COLUMNS).reduce((a: any, key) => {a[key] = <LoadText height={'22px'} />; return a}, {id: Math.random()})
    const loadingDataSet = () => [...new Array(5)].map(_ => getLoadingRow())


    const getTableData = () => responders.map(u => ({
        id: u.id,
        name: <div className={styles.Name}>{u.name}</div>,
        role: <div className={styles.Role}>Responder</div>,
    }));



    return <section className={styles.ResponderStaff}>
        <Header>
            Responder Staff
        </Header>
        <ScrollTable
            message={responders.length === 0 ? 'No active responders.' : ''}
            className={styles.Table}
            columns={COLUMNS}
            data={loading ? loadingDataSet() : getTableData()}
        />
    </section>
}